// Runtime polyfills that MUST run before any other module evaluates — imported
// first in index.js. pdfjs-dist 4.x (bundled by react-pdf 9) calls
// `Promise.withResolvers()`, which only exists in Chrome/Edge 119+, Safari
// 17.4+, Firefox 121+ and Node 22+. On any older browser or embedded WebView
// the call throws and EVERY PDF preview fails to render (while the download
// link, which doesn't touch pdfjs, still works) — the exact symptom of
// "Не удалось отобразить PDF". This guarded shim is a no-op on modern engines.
if (typeof Promise.withResolvers !== "function") {
  // eslint-disable-next-line no-extend-native
  Promise.withResolvers = function withResolvers() {
    let resolve;
    let reject;
    const promise = new Promise((res, rej) => {
      resolve = res;
      reject = rej;
    });
    return { promise, resolve, reject };
  };
}
